import { render, staticRenderFns } from "./SmallVideoPlayer.vue?vue&type=template&id=3d149009&scoped=true&"
import script from "./SmallVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./SmallVideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./SmallVideoPlayer.vue?vue&type=style&index=0&id=3d149009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d149009",
  null
  
)

export default component.exports